/**
 * Created by Marcus Zhao on 12/1/2020
 * Description:
 *
 * ---------maintenance history-------------
 * updated by Alan Yang on 4/27/2023
 * Unify the UI design for Task template and Contact template.
 */
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { TemplateSettingDialogService } from '../template-setting-dialog.service';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import * as _lodash from 'lodash';
import { SettingConfig, ActionType, FieldType, contactDefField } from '../template-setting-dialog.model';
import { OnDestroy } from '@angular/core';
import { ControlId } from '../../contact-dialog-new/contact-dialog.model';
import { DefaultWordCites } from '../../../tamalelibs/constants/DefaultWorldCities.constants';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { MultiSelDropdownConfig, MultiSelDropdownFilterConfig } from '../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import { EntityType } from '../../../tamalelibs/models/entity-type.model';
import { Store, select } from '@ngrx/store';
import { availableEntityTypeSelector } from '../../../redux/reducers/entity-type.reducer';
import { AppState } from '../../../redux';
import { ArrayHelperService } from '../../../tamalelibs/services/array-helper.service';


@Component({
    selector: 'tam-template-setting-config',
    templateUrl: './template-setting-config.component.html',
    styleUrls: ['./template-setting-config.component.scss']
})
export class TemplateSettingConfigComponent implements OnInit, OnDestroy {
    @Input() config;
    @ViewChild('dropDownEl', { static: false }) dropDownEl: DropDownListComponent;
    columnSize = [25, 50, 75, 100];
    defaultOptionsItems = [];
    defaultOptionsSource = '';
    defaultOptions = [];
    isShowJobTitleFly = false;
    showAddressTip = false;
    showEmailTip = false;
    showSection = false;
    isShowExistTip = false;
    tipValue = '';
    sectionName = '';
    optionsItems = [];
    optionItemsPrefix = [
        { 'name': 'Mr', 'fix': true },
        { 'name': 'Ms', 'fix': true },
        { 'name': 'Mrs', 'fix': false },
        { 'name': 'Atty.', 'fix': false },
        { 'name': 'Prof.', 'fix': false },
        { 'name': 'Hon.', 'fix': false }];
    optionItemsSuffix = [
        { 'name': 'Jr', 'fix': true },
        { 'name': 'Sr', 'fix': true },
        { 'name': 'II', 'fix': false },
        { 'name': 'III', 'fix': false },
        { 'name': 'IV', 'fix': false },
        { 'name': 'CFA', 'fix': false },
        { 'name': 'CPA', 'fix': false },
        { 'name': 'PhD', 'fix': false },
        { 'name': 'MD', 'fix': false },
        { 'name': 'DO', 'fix': false },
        { 'name': 'DDS', 'fix': false },
        { 'name': 'LLD', 'fix': false }];
    optionItemsGender = [
        { 'name': 'Male', 'fix': true },
        { 'name': 'Female', 'fix': true }];
    selectedIndex = 0;
    selectedItem;
    isPPCUser: boolean;
    isShowOptions = false;
    isShowChecked = false;
    isCheck = false;
    isFlyCheck = false;
    inputValue: string;
    childConfig: any;
    valueCountryList = [];
    valueCountry = 'United States';
    private _currentUser;
    private _destroySubscriptions: Array<Subscription> = [];
    private _field: SettingConfig;
    entityTypeData = [EntityType.CONTACT];
    entityTypeConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig(true);
    dropdownConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    allEntityTypes = [];
    showCompanyDropdown: boolean;
    constructor(
        private _templateSettingService: TemplateSettingDialogService,
        private _storeQuerier: StoreQuerierService,
        private _store: Store<AppState>) {
        this._currentUser = this._storeQuerier.getCurrentUser();
    }

    ngOnInit() {
        this.isPPCUser = this._currentUser.credential.publishPubConfiguration;
        this.valueCountryList = Array.from(new Set(DefaultWordCites.map(data => data.country).sort()));
        this.entityTypeData.forEach(item => {
            this.entityTypeConfig.data.push(MultiSelDropdownConfig.parse(item.id, true, item.name, '', false));
        });
        this._destroySubscriptions.push(
            this._templateSettingService.actionSubject$.subscribe(item => this._settingTemplateField(item)));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    /**
     * resize layout width
     *
     * @param {*} event
     * @param {*} item
     * @param {*} index
     * @memberof TemplateSettingConfigComponent
     */
    clickColumnSize(event, item, index) {
        this.selectedIndex = index;
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.RESIZE, this._field.data, item / 100));
    }

    /**
     *
     *
     * @memberof TemplateSettingConfigComponent
     */
    changeDropdownValue(event) {
        this.isShowExistTip = false;
    }

    /**
     * required check
     *
     * @param {*} event
     * @memberof TemplateSettingConfigComponent
     */
    oncheckedChange(event) {
        this.childConfig.config.isRequired = this.isCheck;
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.CHECKREQUIRED, this._field.data, ''));
    }

    oncheckedFlyChange(event) {
        this.childConfig.config.isAllowFly = this.isFlyCheck;
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.CHECKREQUIRED, this._field.data, ''));
    }

    /**
     * country chanage will trigger state chagne
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueCountry(item) {
        this.childConfig.config.defaultValueCountry = item;
    }

    /**
    * input default value
    *
    * @param {*} event
    * @memberof TemplateSettingConfigComponent
    */
    enterValue(event) {
        const optionsList = [];
        const data = _lodash.cloneDeep(this.defaultOptionsSource.split('\n').filter(item => item));
        data.forEach(item => {
            const option = { name: item, fix: false };
            optionsList.push(option);
        });
        this.childConfig.dataSource = optionsList;
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.CHANGE_CONFIG, this._field.data, ''));
    }

    /**
     * set config for current field
     *
     * @private
     * @param {SettingConfig} field
     * @memberof TemplateSettingConfigComponent
     */
    private _settingTemplateField(field: SettingConfig) {
        if (field.action === ActionType.ADDCONFIG || field.action === ActionType.SELECT || field.action === ActionType.DELETE || field.action === ActionType.CLICK_SECTION) {
            this._field = field;
            this.childConfig = field.location;
            this.isShowOptions = false;
            this.isShowChecked = false;
            this.showSection = false;
            this.showAddressTip = false;
            this.isShowJobTitleFly = false;
            this.showCompanyDropdown = false;
        }
        if (field.action === ActionType.ADDCONFIG) {
            this.defaultOptionsItems = [];
            this.defaultOptionsSource = '';
            this.isCheck = this.childConfig.config.isRequired;
            if (field.data.type === FieldType.singleDropdown) {
                this.isShowOptions = true;
                if (field.data.name === contactDefField.Prefix) {
                    this.defaultOptionsItems = this.optionItemsPrefix;
                    this.defaultOptionsSource = this.optionItemsPrefix.map(item => item.name).join('\n');
                } else if (field.data.name === contactDefField.Suffix) {
                    this.defaultOptionsItems = this.optionItemsSuffix;
                    this.defaultOptionsSource = this.optionItemsSuffix.map(item => item.name).join('\n');
                } else if (field.data.name === contactDefField.Gender) {
                    this.defaultOptionsItems = this.optionItemsGender;
                    this.defaultOptionsSource = this.optionItemsGender.map(item => item.name).join('\n');
                } else {
                    this.defaultOptionsItems = [];
                    this.defaultOptionsSource = '';
                    this.isShowOptions = false;
                }
                this.childConfig.dataSource = this.defaultOptionsItems;
            } else {
                this.isShowOptions = false;
            }
        } else if (field.action === ActionType.SELECT) {
            this.defaultOptionsItems = [];
            this.defaultOptionsSource = '';
            // Control what is in the Company dropdown
            this.showCompanyDropdown = this.childConfig.config.controlID === ControlId.Company;
            if (this.showCompanyDropdown) {
                this._initSubscriptions();
            }
            // Hide Required fields except : First Name, Company, Job Title, Job Function, Email
            const hideRequiredFields = [ControlId.FirstName, ControlId.Company, ControlId.JobTitle, ControlId.JobFunction, ControlId.Email];
            this.isShowChecked = hideRequiredFields.some((item) => this.childConfig.config.controlID === item);
            // Allowing PPC user to disable the ability of create job title on the fly
            if (this.childConfig.config.controlID === ControlId.JobTitle || this.childConfig.config.controlID === ControlId.FormerEmployment) {
                this.isShowJobTitleFly = true;
            }

            // check singleDropdown
            if (field.data.type === FieldType.singleDropdown) {
                this.defaultOptionsItems = this.childConfig.dataSource;
                this.defaultOptionsSource = this.defaultOptionsItems.map(item => item.name).join('\n');
                if (!this.childConfig.dataSource) {
                    this.isShowOptions = false;
                } else {
                    const hideOptionsTypes = [ControlId.Address, ControlId.Phone, ControlId.Email, ControlId.Internet];
                    if (hideOptionsTypes.every(item => this.childConfig.config.controlID !== item)) { // Hide options for adding new types of Address/Phone/Email/Internet
                        this.isShowOptions = true;
                        this.inputValue = '';
                        this.isShowExistTip = false;
                    }
                }
            }

            if (field.data.type === FieldType.combineDropdownInput || field.data.type === FieldType.address) {
                this.defaultOptionsItems = this.childConfig.dataSource;
                if (!this.childConfig.dataSource) {
                    this.isShowOptions = false;
                } else {
                    const hideOptionsTypes = [ControlId.Address, ControlId.Phone, ControlId.Email, ControlId.Internet];
                    if (hideOptionsTypes.every(item => this.childConfig.config.controlID !== item)) { // Hide options for adding new types of Address/Phone/Email/Internet
                        this.isShowOptions = true;
                        this.inputValue = '';
                        this.isShowExistTip = false;
                    }
                }
            }
            if (field.data.type === FieldType.address) {
                this.showAddressTip = true;
                this.valueCountry = this.childConfig.config.defaultValueCountry;
            } else {
                this.showAddressTip = false;
            }
            if (field.data.name === ControlId.Email) {
                this.showEmailTip = true;
            } else {
                this.showEmailTip = false;
            }
            this.isCheck = this.childConfig.config.isRequired;
            this.isFlyCheck = this.childConfig.config.isAllowFly;
        } else if (field.action === ActionType.DELETE) {
            this.defaultOptionsItems = [];
            this.defaultOptionsSource = '';
            this.childConfig.dataSource = [];
            this.isShowOptions = false;
        } else if (field.action === ActionType.CLICK_SECTION) {
            this.childConfig = null;
            this.showSection = true;
            this.sectionName = field.location;
        }
    }

    private _initSubscriptions() {

        this._destroySubscriptions.push(

            this._store.pipe(select(availableEntityTypeSelector))
                .subscribe(res => this._onSubscribeEntityTypesList(res)),

            this.dropdownConfig.onChangeValue$.subscribe(data => {
                if (data === EntityType.ALL.name) {
                    this.childConfig.config['source'] = data;
                } else {
                    this.childConfig.config['source'] = data.map(item => item.id);
                }
                this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.CHANGE_CONFIG, this._field.data, '', this.childConfig.config));
            }));

    }
    private _onSubscribeEntityTypesList(item: Array<any>): void {
        // remove EntityType'Team'
        item = item.filter(data => data.name !== 'Team');
        this.allEntityTypes = item;
        if (this.allEntityTypes) {
            if (item && item.length > 0) {
                ArrayHelperService.sort(item, 'name');

                this.dropdownConfig.data = item.map(data => {
                    if (this.childConfig.config.source) {
                        if (this.childConfig.config.source !== EntityType.ALL.name) {
                            return {
                                id: data.id,
                                checked: this.childConfig.config.source.includes(data.id),
                                name: data.name
                            };
                        } else {
                            return {
                                id: data.id,
                                checked: true,
                                name: data.name
                            };
                        }

                    } else {
                        return {
                            id: data.id,
                            checked: true,
                            name: data.name
                        };
                    }

                });
            }
        }
    }

}
